import React from 'react';
import { withTranslation } from 'react-i18next';
import { ModalBody  } from 'reactstrap';
import { modalWrapper } from 'components/FDModal';

const DisplayError = props => {
    return (
        <ModalBody>
            <div className="text-center mb-3">
                <span className="icon-warning-square font50"></span>
                <p className="text-14">{props.errMsg}</p>
            </div>            
        </ModalBody>
    )
}

export default withTranslation('translations')(modalWrapper(true, "DisplayErrorModal")(DisplayError));